import React from "react";
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/filter-bar.module.scss";
import {ACTION_TYPES} from "../../../core/consts";
import {FilterBarModuleButton} from "./filter-bar-module.button";
import {FILTER_BAR_MODULE} from "../filter-bar-module.consts";

export const FilterBarModuleQuickAccessButtons = observer(({
                                                             isLive,
                                                             showOdds,
                                                             controller,
                                                             onLiveClick,
                                                             onToggleClick,
                                                             onShowOddsClick,
                                                             shouldRenderLiveButton
                                                           }) => {
  const {state, terms} = controller;
  const {showOdds: appShowOdds, showOddsButton} = state;
  const {SETTINGS_ODDS, LIVE} = terms;

  const oddsButtonProps = {
    label: SETTINGS_ODDS,
    shouldRenderButton: showOddsButton,
    isActive: showOdds !== undefined ? showOdds && appShowOdds : appShowOdds,
    className: styles.odds_button,
    onClick: () => {
      if ((showOdds === undefined) || (showOdds === appShowOdds)) {
        onShowOddsClick?.(!(showOdds && appShowOdds));
        onToggleClick(FILTER_BAR_MODULE.ANALYTICS.TOGGLE_TYPES.odds, !appShowOdds);
        controller.action(ACTION_TYPES.toggleShowOdds, {isActive: appShowOdds, disableAnalytics: true});
      } else {
        onShowOddsClick?.(!showOdds);
      }
    }
  }

  const liveButtonProps = {
    label: LIVE,
    shouldRenderButton: shouldRenderLiveButton,
    isActive: isLive,
    className: styles.live_button,
    onClick: () => {
      onToggleClick(FILTER_BAR_MODULE.ANALYTICS.TOGGLE_TYPES.live, !isLive);
      onLiveClick?.();
    }
  }

  return <div className={classNames(styles.quick_access_button)}>
    <FilterBarModuleButton {...liveButtonProps}/>
    <FilterBarModuleButton {...oddsButtonProps}/>
  </div>
});
